import React from 'react';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import CustomizedLabel from '../../hookForms/CustomizedLabel';
import InputWithController from '../../hookForms/InputWithController';
import SelectWithController from '../../hookForms/SelectWithController';
import { iKeyValuePairs } from '../../UITypes/types';
import { INCLUDE_LOGO_OPTION } from './RollPrint.constants';
import { handleNullException } from '../../../services/UtilsService';
import { FlexContainer, SpaceHorizontalWrapper, SpaceVerticalWrapper } from '../../styles/styles';

const RollPrintBody = ({
  control,
  onChange,
  errors,
  watch,
  defaultValues,
}: {
  //  eslint-disable-next-line
  control: Control<Record<string, any>>;
  //    eslint-disable-next-line
  onChange: (name: string, value: any, config?: Object) => void;
  //    eslint-disable-next-line
  errors: DeepMap<Record<string, any>, FieldError>;
  // eslint-disable-next-line
  watch: (names?: string | string[]) => any;
  defaultValues?: iKeyValuePairs;
}) => {
  const rollNumber = handleNullException(defaultValues, 'rollNumber');
  return (
    <div>
      <InputWithController
        control={control}
        errors={errors}
        onChange={onChange}
        defaultValue={handleNullException(defaultValues, 'length')}
        name={'length'}
        label={'Length(m)'}
        isRequired
        isNumeric
        type={'number'}
        testId={'length'}
      />
      <InputWithController
        control={control}
        errors={errors}
        onChange={onChange}
        defaultValue={handleNullException(defaultValues, 'nominalWeight')}
        name={'nominalWeight'}
        label={'Nominal Weight(kg)'}
        isRequired
        isNumeric
        type={'number'}
        testId={'nominalWeight'}
      />
      <SelectWithController
        control={control}
        errors={errors}
        onChange={onChange}
        options={INCLUDE_LOGO_OPTION}
        defaultValue={handleNullException(defaultValues, 'includeLogo')}
        name={'includeLogo'}
        label={'Print with logo'}
        isRequired
        testId={'includeLogo'}
      />
      <SpaceVerticalWrapper className={'x-small'} />
      <CustomizedLabel label={'Roll Number Range:'} />
      <FlexContainer className={'flex-start'}>
        <InputWithController
          control={control}
          errors={errors}
          onChange={onChange}
          defaultValue={1}
          name={'rollNumberFrom'}
          label={'Roll number from'}
          isRequired
          isNumeric
          type={'number'}
          range={{ min: 1, max: watch('rollNumberTo') || rollNumber }}
          testId={'rollNumberFrom'}
        />
        <SpaceHorizontalWrapper className={'x-small'} />
        <InputWithController
          control={control}
          errors={errors}
          onChange={onChange}
          defaultValue={rollNumber}
          name={'rollNumberTo'}
          label={'Roll number to'}
          isRequired
          isNumeric
          type={'number'}
          range={{ min: watch('rollNumberFrom') || 1, max: rollNumber }}
          testId={'rollNumberTo'}
        />
      </FlexContainer>
    </div>
  );
};

export default RollPrintBody;
